import { createSelector } from "reselect";

import getPartsState from "./getPartsState";

const getPartsPagination = createSelector(getPartsState, ({ meta }) => ({
  page: meta?.pagination.page,
  pages: meta?.pagination.pages,
}));

export default getPartsPagination;
